<template>
  <div class="app-page learning b-modal">
    <vue-headful title="ALICE | Learning"></vue-headful>
    <div class="page-header head-row">
      <div class="page-header-content header-elements-md-inline">
        <div class="d-flex">
          <div class="breadcrumb page-title">
            <h4>
              <a href="#" class="breadcrumb-item">
                <em class="icon-reading"></em>
                <span class="font-weight-semibold ml-2 breadcrumb-item">Understanding</span>
              </a>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="app-page-content">
      <div class="page-column issue-column">
        <div class="title-toolbar">
          <div class="title-toolbar-text">
            TO BE LEARN
            <span class="badge badge-pill bg-pink-300 font-size-sm">
              {{pageData.totalElements}}
            </span>
          </div>
          <div class="title-toolbar-filter">
            <div class="select is-small mr-2">
              <select v-model="issueFilterStatus" @change="reloadCurrentPage">
                <option value="ALL">All</option>
                <option value="NEW">Uncategorized</option>
                <option value="RESOLVING">Categorized</option>
                <option value="RESOLVED">Resolved</option>
              </select>
            </div>

            <button class="btn btn-sm btn-primary" @click="toggleExportModal(true)">
              <i class="fas fa-download mr-1"></i> Export
            </button>
            <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
            <div id="download-area"></div>

          </div>

        </div>
        <div class="content-wrapper">
          <table class="table is-hoverable is-fullwidth">
            <colgroup>
              <col span="1" style="width: 20%;"/>
              <col span="1" style="width: 10%;"/>
              >
              <col span="1" style="width: 60%;"/>
              <col span="1" style="width: 10%;"/>
            </colgroup>
            <thead>
              <tr>
                <th class="has-text-centered">Created at</th>
                <th></th>
                <th>Message</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="issue in issuesList"
                :key="issue.id"
                :class="{'selected-row': selectedMessageId === issue.id}"
              >
                <td
                  class="has-text-centered date-column"
                  @click="selectMessage(issue.id, issue.text)"
                >
                  <em class="icon-calendar2 mr-2"></em>
                  {{convertTime(issue.updated_at)}}
                </td>
                <td>
                  <em
                    v-if="issue.status === 'RESOLVING' &&
                    issue.resolving_reason &&
                    issue.resolving_reason.type &&
                    issue.resolving_reason.type === 'MODEL'"
                    class="fa fa-exclamation-triangle text-orange-300"
                    rel="tooltip"
                    title="required model training"
                  ></em>
                </td>
                <td @click="selectMessage(issue.id, issue.text)">{{issue.text}}</td>
                <td class="list-btn-action has-text-right">
                  <div class="list-icons">
                    <span
                      v-if="issue.status === 'RESOLVING'"
                      class="badge badge-success mr-4 resolving-btn"
                      @click="resolveAskIssue(issue.id)"
                      title="Resolve this issue"
                    >Resolve</span>
                    <!--                        <span-->
                    <!--                          class="list-icons-item btn btn-sm no-padding"-->
                    <!--                          title="Add to benchmark dataset"-->
                    <!--                        >-->
                    <!--                          <em class="fas fa-database"></em>-->
                    <!--                        </span>-->
                    <button
                      class="list-icons-item btn btn-sm no-padding"
                      :class="{'text-muted disabled': issue.status !== 'NEW'}"
                      :disabled="issue.status !== 'NEW'"
                      @click="removeMessage(issue)"
                      title="Remove this message"
                    >
                      <em class="fas fa-trash"></em>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="footer-bar">
          <bootstrap-pagination
            v-model="currentPage"
            :total-rows="pageData.totalElements"
            :per-page="pageSize"
            align="left"
            size="sm"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            @change="changePage"
          ></bootstrap-pagination>
        </div>
      </div>
      <understanding-block
        :modelList="modelList"
        :ruleSet="ruleSet"
        v-on:added="reloadCurrentPage"
        v-bind:selectedMessage="selectedMessageText"
        v-on:testClicked="selectMessage"
      ></understanding-block>
      <div class="page-column resolution-column">
        <span
          class="sub-label text-uppercase font-size-sm font-weight-semibold"
        >Message category</span>
        <button class="btn btn-sm btn-primary btn-trainall" @click="trainAll" v-if="messageActionMode === 'model'">Train All Model</button>
        <div class="full-center-flex dark-mode" v-if="selectedMessageId === ''">
          <div class="text-center">Please select a message</div>
        </div>
        <div class="flex-section tool-content" v-else-if="selectedMessageId !== ''">
          <b-button-group>
            <b-button
              @click="messageActionMode = 'model'"
              :pressed="messageActionMode === 'model'"
              variant="outline-primary"
            >Model</b-button>
            <b-button
              @click="messageActionMode = 'rulebase'"
              :pressed="messageActionMode === 'rulebase'"
              variant="outline-primary"
            >Rule-based</b-button>
          </b-button-group>
          <div class="break-line"></div>
          <div class="field" v-if="messageActionMode === 'model'">
            <label class="text-muted">Please select model and category</label>
          </div>
          <div class="model-result-wrapper" v-if="messageActionMode === 'model'">
            <div class="model-result">
              <div
                class="custom-control custom-checkbox"
                v-for="model in modelList"
                :key="model.id"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="`model-${model.id}`"
                  v-model="selectedModel[model.id]"
                  @change="loadCategoryToList(model.id)"
                />
                <label class="custom-control-label" :for="`model-${model.id}`">
                  {{model.name}}
                </label>
                <div class="form-group pt-2" v-if="selectedModel[model.id]">
                  <div
                    class="custom-control custom-radio"
                    v-for="category in multiCategoryList[model.id]"
                    :key="category.id"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      :name="`model-category-${model.id}`"
                      :checked="selectedCategoryModel[model.id] === category.id"
                      @click="selectedCategoryModel[model.id] = category.id"
                    />
                    <label
                      class="custom-control-label font-size-sm"
                      @click="selectedCategoryModel[model.id] = category.id"
                    >{{category.name}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom-tool">
              <button
                type="button"
                class="btn btn-sm btn-primary w-100"
                @click="addToModel"
                :disabled="!selectedModelAndCategory"
              >Add</button>
              <label
                class="text-muted font-size-sm mt-2"
              >The added message is required model training for completely learning</label>
            </div>
          </div>
          <div class="rulebased-wrapper" v-else-if="messageActionMode === 'rulebase'">
            <div class="field">
              <div class="control">
                <input
                  v-model="ruleFilterInput"
                  type="text"
                  class="input is-small"
                  placeholder="Search by rule name or keyword"
                  @keyup="resetActiveRule"
                />
              </div>
            </div>
            <div class="rulebased-box">
              <table class="table is-hoverable is-fullwidth">
                <tbody>
                <tr
                  v-for="rule in filteredRulesList"
                  :key="rule.id"
                  :class="{'is-active': rule.id === activeRuleId}"
                >
                  <td>
                    <div class="text-row" @click="toggleRule(rule.id)">
                      <span
                        class="text-row-item"
                        :class="{'text-danger': noAnswers(rule.answers)}"
                      >
                        <span
                          v-if="noAnswers(rule.answers)"
                          title="This rule has no answers yet
                          , please add one in the rule-based page."
                        >
                          <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                        </span>
                        {{rule.setName}} > {{rule.name}}
                      </span>
                      <span class="right-row-item">
                        <font-awesome-icon v-if="rule.id === activeRuleId"
                                           icon="caret-up"></font-awesome-icon>
                        <font-awesome-icon v-else
                                           icon="caret-down"></font-awesome-icon>
                      </span>
                    </div>
                    <div class="form-group mb-1" v-if="rule.id === activeRuleId">
                      <label class="text-muted">Keyword(s)</label>
                      <div class="d-flex flex-wrap align-items-center">
                        <button
                          type="button"
                          class="btn btn-sm bg-grey mr-2 mb-2"
                          v-for="keyword in rule.keywords"
                          :key="keyword"
                        >{{keyword}}</button>
                        <button
                          type="button"
                          class="btn btn-sm bg-primary mr-2 mb-2 pr-1 pl-2"
                          v-for="(newKey, index) in tempRuleMap[rule.id]"
                          :key="newKey"
                        >
                          {{newKey}}
                          <span
                            class="badge badge-primary badge-pill"
                            @click="removeTempKeyword(rule.id, index)"
                          >
                            <em class="fas fa-times font-size-xs"></em>
                          </span>
                        </button>
                      </div>
                    </div>
                    <div class="input-group mb-2" v-if="rule.id === activeRuleId">
                      <div class="form-group-feedback">
                        <input
                          type="text"
                          class="form-control form-control-sm alpha-grey"
                          placeholder="New keyword"
                          v-model.trim="ruleKeywordInput"
                          @keyup.enter="addMessageToRule(rule.id, rule.keywords)"
                        />
                      </div>
                      <div class="input-group-append">
                        <button
                          type="submit"
                          class="btn btn-primary btn-sm"
                          @click="addMessageToRule(rule.id, rule.keywords)"
                        >
                          <em class="fa fa-plus"></em>
                        </button>
                      </div>
                    </div>
                    <div
                      class="text-row no-answer message is-danger"
                      v-if="rule.id === activeRuleId && noAnswers(rule.answers)"
                    >
                      <span>This rule has no answers.&nbsp;</span>
                      <a
                        class="no-margin is-danger-link"
                        @click="goRuleBasedPage(rule.setId, rule.id)"
                      >Add one</a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="bottom-field text-center">
              <button
                type="button"
                class="btn btn-sm btn-success w-100"
                @click="saveKeyword"
              >Save</button>
              <button
                type="button"
                class="btn btn-link w-100"
                @click="toggleNewRuleModal(true)"
              >New rule-based</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" :class="{'is-active': newRuleModal.open }">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <header class="card-header">
            <p class="card-header-title">Add new rule</p>
          </header>
          <div class="card-content">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label no-margin">Rule set</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="select is-fullwidth">
                    <select v-model="newRuleModal.ruleSetId">
                      <option value>
                        Please select rule set
                      </option>
                      <option v-for="set in ruleSetList" :key="set.id" :value="set.id">
                        {{set.name}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label no-margin">Rule name</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <input
                    type="text"
                    class="input"
                    placeholder="Enter a new rule name"
                    v-model="newRuleModal.ruleName"
                  />
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer right-card-footer">
            <button class="btn btn-sm"
                    @click="toggleNewRuleModal(false)">Cancel</button>
            <button class="btn btn-sm btn-info"
                    @click="saveNewRule" :disabled="invalidNewRule">Add</button>
          </footer>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close"
              @click="toggleNewRuleModal(false)"></button>
    </div>
    <!-- modal export -->
    <div class="modal" :class="{'is-active': isOpenExportModal }">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <header class="card-header">
            <p class="card-header-title">Select Date and Time</p>
          </header>
          <div class="card-content">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label no-margin">From</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="control is-expanded has-icons-left">
                    <datetime
                      :max-datetime="dateTo"
                      type="datetime"
                      input-class="input"
                      v-model="dateFrom"
                    ></datetime>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                    </span>
                </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label no-margin">To</label>
              </div>
              <div class="field-body">
                <div class="field is-expanded">
                  <div class="control is-expanded has-icons-left">
                    <datetime
                      :min-datetime="dateFrom"
                      :max-datetime="dateNow"
                      type="datetime"
                      input-class="input"
                      v-model="dateTo"
                    ></datetime>
                    <span class="icon is-small is-left">
                      <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer right-card-footer">
            <button class="btn btn-sm"
                    @click="toggleExportModal(false)">Cancel</button>
            <button class="btn btn-sm btn-info"
                    @click="exportNotUnderstandLog" :disabled="!dateFrom && !datetime">Export</button>
          </footer>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close"
              @click="toggleExportModal(false)"></button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { BPagination, BButtonGroup, BButton } from 'bootstrap-vue';
import moment from 'moment';
import understandingBlock from '../../components/Learning/UnderstandingBlock.vue';
import alice from '../../alice-api';

export default {
  name: 'learning-v1',
  components: {
    'bootstrap-pagination': BPagination,
    'b-button-group': BButtonGroup,
    'b-button': BButton,
    'understanding-block': understandingBlock,
  },
  data() {
    return {
      // Issues
      selectedMessageText: '',
      selectedMessageId: '',
      messageActionMode: 'model',
      issueFilterStatus: 'ALL',
      ruleFilterInput: '',
      ruleKeywordInput: '',
      activeRuleId: '',
      currentPage: 1,
      pageSize: 25,
      tempRuleMap: {},
      originalRuleMap: {},
      newRuleModal: {
        open: false,
        ruleSetId: '',
        ruleName: '',
      },
      multiCategoryList: {},
      selectedModel: {},
      selectedCategoryModel: {},
      // Export not understand
      dateFrom: '',
      dateTo: '',
      dateNow: '',
      isOpenExportModal: false,
      isLoading: false,
    };
  },
  async mounted() {
    this.initDateExport(7);
    this.resetCategoryList();
    this.loadModelList();
    this.loadRuleSet();
    this.loadRulesList();
    this.currentPage = 1;
    await this.reloadCurrentPage();
  },
  methods: {
    ...mapActions({
      loadRuleSet: 'rulebase/loadRuleSet',
      saveRuleKeywordFromId: 'rulebase/saveRuleKeywordFromId',
      setPreSelectRule: 'persist/setPreSelectRule',
      createRule: 'rulebase/createRule',
      createToBeTrainMessage: 'train/createToBeTrainMessage',
      updateToBeTrainMessage: 'train/updateToBeTrainMessage',
      createResolveToBeTrainMessage: 'train/createResolveToBeTrainMessage',
      createQuestion: 'train/createQuestion',
      resolveIssue: 'issues/resolveIssue',
      markResolveIssue: 'issues/markResolveIssue',
      loadIssuesList: 'issues/loadIssuesList',
      loadIssuesCount: 'issues/loadIssuesCount',
      deleteIssue: 'issues/deleteIssue',
      loadModelList: 'issues/loadModelList',
      loadCategoryList: 'issues/loadCategoryList',
      resetCategoryList: 'issues/resetCategoryList',
      loadRulesList: 'issues/loadRulesList',
      modelReloadList: 'model/loadModelList',
    }),
    initDateExport(number) {
      const now = moment();
      this.dateNow = now.toISOString();
      this.dateTo = now.toISOString();
      this.dateFrom = now
        .subtract(number, 'days')
        .startOf('day')
        .toISOString();
    },
    exportNotUnderstandLog() {
      this.isOpenExportModal = false;
      this.isLoading = true;
      let status;
      if (this.issueFilterStatus === 'ALL') {
        status = [];
      } else {
        status = [this.issueFilterStatus];
      }
      alice.exportNotUnderstand(this.dateFrom, this.dateTo, status)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const elem = document.getElementById('download-area');
          link.href = url;
          link.setAttribute('download', 'not_understand_log.xlsx');
          elem.innerHTML = '';
          elem.appendChild(link);
          link.click();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred, cannot export logs data.',
            position: 'is-bottom',
          });
        });
    },
    toggleExportModal(state) {
      this.isOpenExportModal = state;
    },
    // train all model
    trainAll() {
      alice.trainAllModel()
        .then(() => {
          if (this.$buefy.toast) {
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'Successfully train all',
              position: 'is-bottom',
              duration: 5000,
            });
          }
        })
        .catch(() => {
          if (this.$buefy.toast) {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Error occur while train-all',
              position: 'is-bottom',
              duration: 5000,
            });
          }
        });
    },
    // Issues
    selectMessage(id, text) {
      // console.log(text);
      if (this.dirtyRules) {
        this.$buefy.dialog.confirm({
          title: 'Discard changes',
          message:
              'You have some unsaved changes for rule keywords, do you want to discard those changes?',
          cancelText: 'Keep',
          confirmText: 'Discard',
          type: 'is-warning',
          hasIcon: true,
          onConfirm: () => {
            this.tempRuleMap = {};
            this.setNewActiveMessage(id, text);
          },
        });
      } else {
        this.setNewActiveMessage(id, text);
      }
    },
    setNewActiveMessage(id, text) {
      this.selectedMessageId = id;
      this.selectedMessageText = text || '';
      this.activeRuleId = '';
      this.messageActionMode = 'model';
      // Remove this if need to save next message quickly without toggle category again
      this.selectedModel = {};
      this.selectedCategoryModel = {};
    },
    toggleRule(ruleId) {
      // console.log('TOGGLE', ruleId);
      if (this.activeRuleId === ruleId) {
        this.activeRuleId = '';
      } else {
        this.activeRuleId = ruleId;
      }
    },
    reloadCurrentPage() {
      let status;
      if (this.issueFilterStatus === 'ALL') {
        status = [];
      } else {
        status = [this.issueFilterStatus];
        this.loadIssuesCount().then(() => {
        });
      }
      return this.loadIssuesList({
        page: this.currentPage,
        size: this.pageSize,
        status,
      });
    },
    async changePage(page) {
      this.currentPage = page;
      await this.reloadCurrentPage();
    },
    async loadCategoryToList(modelId) {
      if (!this.multiCategoryList[modelId]) {
        const list = await this.loadCategoryList({ modelId });
        if (list) {
          Vue.set(this.multiCategoryList, modelId, list);
        }
      }
      if (!this.selectedCategoryModel[modelId]) {
        const first = this.multiCategoryList[modelId][0];
        Vue.set(this.selectedCategoryModel, modelId, first.id);
      }
    },
    removeMessage(issue) {
      const { status, id } = issue;
      if (status === 'NEW') {
        this.$buefy.dialog.confirm({
          title: 'Removing issue',
          message: 'Are you sure to remove this issue?',
          cancelText: 'Keep',
          confirmText: 'Remove',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.deleteIssue({ id }).then(async () => {
              this.$buefy.toast.open({
                type: 'is-success',
                message: 'Issue removed.',
                position: 'is-bottom',
                duration: 3000,
              });
              await this.reloadCurrentPage();
            });
          },
        });
      }
    },
    // Manual resolve
    resolveAskIssue(id) {
      this.$buefy.dialog.confirm({
        title: 'Resolving issue',
        message: 'Are you sure to mark this issue as resolved?',
        cancelText: 'Keep',
        confirmText: 'Resolve',
        type: 'is-success',
        hasIcon: true,
        onConfirm: () => {
          this.markResolveIssue({ id }).then(async () => {
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'Issue resolved.',
              position: 'is-bottom',
              duration: 3000,
            });
            await this.reloadCurrentPage();
          });
        },
      });
    },
    // Resolve by model
    async createToBeTrainMessages() {
      // Each selected model
      const promiseArr = [];
      const message = this.selectedMessageText;
      const rawModelKeys = Object.keys(this.selectedModel);
      for (let i = 0; i < rawModelKeys.length; i += 1) {
        const modelId = rawModelKeys[i];
        const categoryId = this.selectedCategoryModel[modelId];
        if (this.selectedModel[modelId] && categoryId) {
          const reqPromise = this.createQuestion({ modelId, categoryId, message });
          promiseArr.push(reqPromise);
        }
      }
      const response = await Promise.allSettled(promiseArr);
      let success = false;
      // console.log(response);
      response.forEach((question) => {
        if (question.status === 'fulfilled') {
          success = true;
        }
      });
      if (this.$buefy.toast) {
        if (success) {
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Successfully added to model',
            position: 'is-bottom',
            duration: 5000,
          });
        } else {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: `Add fail: ${response[0].reason.data.message}`,
            position: 'is-bottom',
            duration: 5000,
          });
        }
      }
      return response;
    },
    async addToModel() {
      try {
        const result = await this.createToBeTrainMessages();
        if (result) {
          const errorArr = result.filter((obj) => obj.isError);
          if (errorArr.length > 0) {
            // Some error
            this.$buefy.toast.open({
              type: 'is-warning',
              message:
                'Message is not completely added to model',
              position: 'is-bottom',
              duration: 3000,
            });
          } else {
            // All ok.
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'Message added to list successfully.',
              position: 'is-bottom',
              duration: 3000,
            });
            const id = this.selectedMessageId;
            await this.resolveIssue({ id, type: 'MODEL' });
            await this.markResolveIssue({ id });
            await this.reloadCurrentPage();
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'Issue resolved.',
              position: 'is-bottom',
              duration: 3000,
            });
            this.selectedMessageText = '';
            this.selectedMessageId = '';
            this.trainAll();
          }
        }
      } catch (e) {
        // console.log(e);
      }
    },
    // Resolve by keyword -- rule base
    saveRuleKeywords() {
      const saveArr = [];
      Object.keys(this.tempRuleMap).forEach((key) => {
        const newKeyword = this.tempRuleMap[key];
        const oldKeyword = this.originalRuleMap[key];
        const keywords = oldKeyword.concat(newKeyword);
        saveArr.push(this.saveRuleKeywordFromId({
          ruleId: key,
          data: keywords,
        }));
      });
      return Promise.all(saveArr);
    },
    async saveKeyword() {
      try {
        await this.saveRuleKeywords();
        this.tempRuleMap = {};
        const id = this.selectedMessageId;
        await this.resolveIssue({ id, type: 'RULEBASED' });
        await this.markResolveIssue({ id });
        await this.loadRulesList();
        await this.reloadCurrentPage();
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Keyword added, issue should be resolved.',
          position: 'is-bottom',
          duration: 3000,
        });
      } catch (e) {
        // console.log(e);
      }
    },
    // Rulebase actions
    addMessageToRule(id, keywords) {
      // console.log('HEY');
      // Ensure no zero length keywordInput
      const message = this.ruleKeywordInput.trim() || '';
      if (message.length === 0) {
        return false;
      }
      // Add to keyword list and make a request instantly

      if (!this.tempRuleMap[id]) {
        Vue.set(this.tempRuleMap, id, []);
      }
      if (!this.originalRuleMap[IDBCursor]) {
        Vue.set(this.originalRuleMap, id, keywords);
      }
      this.tempRuleMap[id].push(message);
      this.ruleKeywordInput = '';
      return message;
    },
    removeTempKeyword(ruleId, index) {
      this.tempRuleMap[ruleId].splice(index, 1);
    },
    resetActiveRule() {
      this.activeRuleId = '';
    },
    toggleNewRuleModal(state) {
      this.newRuleModal.ruleSetId = '';
      this.newRuleModal.ruleName = '';
      this.newRuleModal.open = state;
    },
    saveNewRule() {
      // Save
      const setId = this.newRuleModal.ruleSetId;
      const data = {
        name: this.newRuleModal.ruleName,
        origin: null,
        parent: null,
        level: 0,
        answers: [[]],
      };
      this.createRule({ setId, data })
        .then((newRule) => {
          this.toggleNewRuleModal(false);
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'New rule is added',
            position: 'is-bottom',
          });
          // Preselect rule from result
          this.activeRuleId = newRule.id;
          // Reload rules
          this.loadRulesList().then(() => {
          });
        })
        .catch((e) => {
          // console.log(e.response);
          if (e.response && e.response.status && e.response.status === 500) {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Cannot add duplicate rule name.',
              position: 'is-bottom',
            });
          } else {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Unexpected error occured.',
              position: 'is-bottom',
            });
          }
        });
    },
    // Others / Helper
    convertTime(time) {
      // console.log('CV', time);
      if (time) {
        return moment(time, 'x').format('DD/MM/YYYY - HH:mm');
      }
      return '---';
    },
    noAnswers(answers) {
      let found = false;
      for (let i = 0; i < answers.length; i += 1) {
        for (let j = 0; j < answers[i].length; j += 1) {
          if (answers[i][j]) {
            found = true;
            break;
          }
        }
        if (found) {
          break;
        }
      }
      return !found;
    },
    goRuleBasedPage(ruleSetId, ruleId) {
      // Preselect rule
      this.setPreSelectRule({ ruleSetId, ruleId });
      // Navigate
      window.open('/knowledge/rule-based', '_blank');
    },
  },
  computed: {
    ...mapGetters({
      issuesList: 'issues/issuesList',
      issuesData: 'issues/issuesData',
      modelList: 'issues/modelList',
      categoryList: 'issues/categoryList',
      rulesList: 'issues/rulesList',
      ruleSetList: 'issues/ruleSetList',
      ruleSet: 'rulebase/ruleSet',
    }),
    pageData() {
      if (this.issuesData) {
        return this.issuesData;
      }
      return {};
    },
    selectedModelAndCategory() {
      // Any model selected with a category
      let found = false;
      Object.keys(this.selectedModel).forEach((modelId) => {
        if (this.selectedModel[modelId] && this.selectedCategoryModel[modelId]) {
          found = true;
        }
      });
      return found;
    },
    filteredRulesList() {
      const searchInput = this.ruleFilterInput.trim().toLowerCase();
      if (searchInput.length > 0 && this.rulesList) {
        return this.rulesList.filter((rule) => {
          const longKeywords = rule.keywords.join('|').toLowerCase();
          const ruleName = rule.name.toLowerCase();
          return ruleName.indexOf(searchInput) > -1 || longKeywords.indexOf(searchInput) > -1;
        });
      } if (this.rulesList) {
        return this.rulesList;
      }
      return [];
    },
    dirtyRules() {
      const objKeys = Object.keys(this.tempRuleMap);
      return objKeys.length > 0;
    },
    invalidNewRule() {
      if (this.newRuleModal.ruleSetId === '') return true;
      const name = this.newRuleModal.ruleName.trim();
      return name.length === 0;
    },
  },
};
</script>
<style lang="scss" scoped>
  .learning {
    .button {
      border-radius: 5px;
    }
    .app-page-content {
      flex: 1 1 auto;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      padding: 15px;
      .page-column {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #ddd;
      }
      .issue-column {
        min-width: 20%;
        border-radius: 3px;
        .title-toolbar {
          padding: 1rem;
          font-size: 1rem;
          display: flex;
          justify-content: space-between;
          min-height: 48px;
        }
        .content-wrapper {
          padding: 0 1rem;
          .table {
            thead {
              th,
              td {
                position: sticky;
                top: -1px;
                background-color: #fafafa;
                font-size: 0.8rem;
                z-index: 10;
              }
            }
            td {
              padding: 1rem;
              font-size: 0.85rem;
              line-height: 1.4rem;
            }
            .date-column {
              white-space: nowrap;
            }
            .selected-row {
              background-color: #c9e7ff;
              color: #154f7e;
              font-weight: 400;
              em {
                color: #154f7e;
              }
            }
          }
          .resolving-btn {
            cursor: pointer;
            &:hover {
              background-color: #328a32;
            }
          }
        }
        .footer-bar {
          border-top: 1px solid #ddd;
          background-color: #fafafa;
          padding: 1rem;
          font-size: 0.8rem;
          .pagination {
            justify-content: start;
          }
        }
      }
      .resolution-column {
        flex: 1 0 25%;
        min-width: 250px;
        max-width: 30%;
        display: flex;
        flex-direction: column;
        background-color: #29303e !important;
        color: #fff;
        margin-left: 1rem;
        position: relative;
        .label {
          color: #fff;
        }
        .sub-label {
          padding: 1rem;
          font-size: 0.8rem;
          margin: 0;
        }
        .btn-trainall{
          margin-bottom: 20px;
          position: absolute;
          top: 10px;
          right: 10px;
        }
        .tool-content {
          padding: 0 0.8em 0.8em 0.8em;
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          .btn-group {
            min-height: 36px;
            .btn {
              min-height: 36px;
            }
          }
          .select {
            border-radius: 5px;
          }
          .selected-model {
            background-color: #444;
          }
          .checkbox-white-text {
            color: #fff;
            margin: 0.5rem;
            &:hover {
              color: #ddd;
            }
          }
          .inner-field {
            padding: 10px 10px 10px 20px;
            border: 2px solid #444;
          }
          .radio {
            font-size: 0.8rem;
            color: #fff;
            input {
              margin-right: 0.5em;
            }
          }
          .break-line {
            border-bottom: 1px solid #384354;
            margin: 1rem 0 1rem 0;
          }
          .model-result-wrapper {
            display: flex;
            flex-direction: column;
            flex: 1 1 auto;
            overflow: auto;
            .model-result {
              flex: 1 1 auto;
              overflow: auto;
            }
            .bottom-tool {
              padding-top: 1rem;
              /*position: sticky;*/
              bottom: -1px;
              flex: 0 0 auto;
              background-color: #29303e;
            }
          }
          .rulebased-wrapper {
            display: flex;
            flex-direction: column;
            flex: 1 1 auto;
            overflow: hidden;
            .rulebased-box {
              overflow-y: auto;
              .table {
                td {
                  background-color: #29303e;
                  border-bottom-color: #42454a;
                }
              }
              .text-row {
                display: flex;
                align-content: space-between;
                flex: 1 1 auto;
                font-size: 0.8rem;
                margin-bottom: 10px;
                cursor: pointer;
                &.no-answer {
                  color: #d39292;
                  font-weight: bold;
                  padding: 10px;
                  cursor: auto;
                  .is-danger-link {
                    text-decoration: underline;
                    cursor: pointer;
                    &:hover {
                      color: #db6868;
                    }
                  }
                }
              }
              .text-row-item {
                flex: 1 1 auto;
                color: #fff;
                margin-bottom: 10px;
                &.text-danger {
                  color: #a82a2a;
                }
              }
              .tags {
                margin-top: 0.5em;
                font-size: 0.8rem;
                margin-bottom: 0;
                min-height: 25px;
                .tag-label {
                  line-height: 1.2em;
                  margin-top: -0.5em;
                  margin-right: 0.5em;
                }
              }
              .right-row-item {
                flex: 0 1 auto;
                color: #fff;
              }
              tr.is-active {
                &:hover {
                  background-color: #fff;
                }
              }
            }
          }
          .bottom-field {
            margin-top: 0.8em;
          }
        }
      }
    }
  }
</style>
